import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  transactionContainer: {
    padding: theme.spacing(2.5),
  },
  transactionHeader: {
    textAlign: "center",
    marginBottom: theme.spacing(2.5),
  },
  transactionDetails: {
    marginBottom: theme.spacing(2.5),
  },
  transactionActions: {
    textAlign: "center",
  },
  transactionButton: {
    marginTop: theme.spacing(1.25),
  },
}));
